




import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroGameDocument } from "@/services/datatypes";
import { collectionName } from "@/services/collection-name";
import { firestore, db } from "@/scripts/firebase";

@Component({
  components: {}
})
export default class StopTimerButton extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly jinroGame!: JinroGameDocument;

  async handleStopTimer() {
    if (!this.jinroGame || !this.jinroGame.currentJinroPlayinfoId) {
      return;
    }

    const jinroPlayinfoId = this.jinroGame.currentJinroPlayinfoId;
    const params = {
      gmTimerStoppedAt: firestore.FieldValue.serverTimestamp(),
      leftSecondsWhenTimerStopped: this.leftSeconds,
      timeUpdated: firestore.FieldValue.serverTimestamp()
    };
    db.collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.jinroplayinfo)
      .doc(jinroPlayinfoId)
      .set({ ...params }, { merge: true });
  }

  get leftSeconds(): number {
    if (!this.$store.state.jinroGamePlayinfo) {
      return 0;
    }
    const now = Math.floor(new Date().getTime() / 1000);
    let leftSeconds = 0;

    if (this.endedAt) {
      leftSeconds = this.endedAt.seconds - now;
    } else {
      const startedAt = this.$store.state.jinroGamePlayinfo
        .startedAt as firebase.firestore.Timestamp;
      const playTimelimitSeconds = this.$store.state.jinroGamePlayinfo
        .playTimelimitSeconds as number;
      if (!startedAt || !playTimelimitSeconds) {
        return 0;
      }
      leftSeconds = startedAt.seconds + playTimelimitSeconds - now;
    }

    return leftSeconds;
  }

  get endedAt(): firebase.firestore.Timestamp | null {
    if (
      !this.$store.state.jinroGamePlayinfo ||
      !this.$store.state.jinroGamePlayinfo.endedAt
    ) {
      return null;
    }
    const endedAt = this.$store.state.jinroGamePlayinfo.endedAt;

    return endedAt;
  }
}
